import { getItemLocation } from "apis/middlewareEndpoints";
import $ from "jquery";
import React from "react";
import { submitFeedbackForm } from "../apis/middlewareEndpoints";
import FormFeedBack from "../components/AccountFeedback";
import { getAuthToken } from "./Auth";
import { instance } from "./Axios";
import { headerConfigFormUploadWithAuthorize } from "./Header";

class FeedBack extends React.Component {
  state = {
    hotel: "",
    loadings: [],
    confirmLoading: false,
    rewardLocationItemData: [],
    submited: false,
  };

  async componentDidMount() {
    const itemLocationData = await getItemLocation();
    this.setState({
      rewardLocationItemData: itemLocationData.data,
    });
  }

  showLoading() {
    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[0] = true;

      return {
        loadings: newLoadings,
      };
    });
  }

  hideLoading() {
    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[0] = false;

      return {
        loadings: newLoadings,
      };
    });
  }

  handleSubmit(params) {
    try {
      let self = this;
      instance();
      self.showLoading();
      $(".action_status").text("");
      self.setState({ submited: false });
      let token = getAuthToken();
      let header = headerConfigFormUploadWithAuthorize(token);
      let hotelData = params.reward_location.split("-");

      const withoutLineBreaks = params.message.replace(/[\r\n]/gm, " ");

      const bodyFormData = new FormData();
      bodyFormData.append("guest_id", params.guest_id);
      bodyFormData.append("inquiry_type_id", 1);
      bodyFormData.append("location_id", 1);
      bodyFormData.append("subject", params.subject);
      bodyFormData.append("message", withoutLineBreaks);
      bodyFormData.append("reward_location_id", hotelData[0]);
      bodyFormData.append("reward_location_name", hotelData[1]);

      const successText = this.props.langData.submit_success;
      const errorText = this.props.langData.submit_error;

      (async () => {
        await submitFeedbackForm(bodyFormData, token)
          .then(function (response) {
            self.hideLoading();

            if (response.status == 200) {
              self.setState({ submited: true });
              $(".action_status").addClass("status_success").text(successText);
            } else {
              $(".action_status").addClass("status_error").text(errorText);
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response);
              self.hideLoading();
            } else if (error.request) {
              console.log(error.request);
              self.hideLoading();
            } else {
              console.log("Error", error.message);
              self.hideLoading();
            }
          });
        $(window).scrollTop(0);
      })();
    } catch (error) {
      console.log(error);
      this.hideLoading();
    }
  }

  render() {
    return (
      <FormFeedBack
        stateProp={this.state}
        props={this.props}
        handleSubmit={(e) => this.handleSubmit(e)}
      />
    );
  }
}

export default FeedBack;
